export default __webpack_public_path__ + "static/media/ez_logo.b1389122.svg";